export default [
  {
    header: 'Полоски',
    resource: 'strips',
    action: 'view',
  },
  {
    title: 'Список полосок',
    route: 'strips-list',
    icon: 'GridIcon',
    tagVariant: 'light-info',
    resource: 'strips',
    action: 'view',
  },
  {
    title: 'Создать полоску',
    route: 'strip-builder-create',
    icon: 'PlusSquareIcon',
    tagVariant: 'light-info',
    resource: 'strips',
    action: 'view',
  },
  {
    title: 'Импорт архива',
    route: 'strip-import-archive',
    icon: 'UploadIcon',
    tagVariant: 'light-info',
    resource: 'strips',
    action: 'view',
  },
  {
    title: 'Импорт SIQ',
    route: 'strip-import-siq',
    icon: 'PackageIcon',
    tagVariant: 'light-info',
    resource: 'strips',
    action: 'view',
  },
]
